import { render, staticRenderFns } from "./ElevatorFooter.vue?vue&type=template&id=76e21fdc&"
import script from "./ElevatorFooter.vue?vue&type=script&lang=js&"
export * from "./ElevatorFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports